<template lang="html">
  <v-app light v-if="isLapTopCheck">
    <v-content>
      <section>
        <v-parallax :src="require('@/assets/parallax.jpg')" height="660">
          <v-layout row align-center justify-center>
            <v-flex xs12>
              <a href="/home">
                <v-img
                  :src="require('@/assets/logo.png')"
                  :lazy-src="require('@/assets/logo.png')"
                  contain
                  height="170">
                </v-img>
              </a>
            </v-flex>
          </v-layout>
          <v-layout column align-center justify-start class="white--text">
              <h1 style="font-size:36px">Naics Furnishing Co., Ltd.</h1>
              <div class="subheading mb-3 text-xs-center">บริษัท แน็กส์ เฟอร์นิชิ่ง จำกัด</div>
              <v-btn
                class="blue darken-2 mt-5"
                dark
                large
                :to="{ name: 'product'}">
                ดูสินค้า <v-icon>shopping_cart</v-icon>
              </v-btn>
          </v-layout>
        </v-parallax>
      </section>

      <section>
        <v-layout
          column
          wrap
          class="my-5"
          align-center>
          <v-flex xs12 sm4 class="my-3">
            <div class="text-xs-center">
              <h1 style="font-size:26px">Naics Furnishing ผู้ผลิตเฟอร์นิเจอร์น็อคดาวน์</h1>
              <span class="subheading">
                ความเชื่อมั่นของลูกค้า คือความภาคภูมิใจของเรา
              </span>
            </div>
          </v-flex>
          <v-carousel class="my-4" height="auto">
            <v-carousel-item
              v-for="(item,i) in allUrl"
              :key="i"
              :src="item.url"
              >
            </v-carousel-item>
          </v-carousel>
          <v-flex xs12>
            <v-container grid-list-xl>
              <v-layout row wrap align-center>
                <v-flex xs12>
                  <v-container grid-list-xl>
                    <v-layout row wrap align-center justify-center>
                      <v-flex xs10 offset-xs5>
                        <h2 style="font-size:26px">สินค้าขายดี</h2>
                      </v-flex>
                      <v-flex xs12 md3 v-for="(value,i) in randomList(popular_product, 4)" :key="i">
                        <v-hover>
                          <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 1}`" class="mx-auto">
                            <div align="center">
                              <!-- i have to make "no product" image  -->
                              <v-img
                                v-if="value.url === ''"
                                :src="require('@/assets/no-product.png')"
                                :lazy-src="require('@/assets/no-product.png')"
                                aspect-ratio="1"
                                max-height="200"
                                contain
                                class="white"
                              >
                                <v-layout
                                  slot="placeholder"
                                  fill-height
                                  align-center
                                  justify-center
                                  ma-0
                                >
                                  <v-progress-circular indeterminate color="blue darken-4"></v-progress-circular>
                                </v-layout>
                              </v-img>
                                <v-img
                                  v-else
                                  :src="value.url"
                                  :lazy-src="value.url"
                                  aspect-ratio="1"
                                  max-height="200"
                                  contain
                                  class="white"
                                >
                                  <v-layout
                                    slot="placeholder"
                                    fill-height
                                    align-center
                                    justify-center
                                    ma-0
                                  >
                                    <v-progress-circular indeterminate color="blue darken-4"></v-progress-circular>
                                  </v-layout>
                                </v-img>
                            </div>
                              <v-card-title primary-title>
                                <div>
                                  <h3 style="font-size:16px">{{ value.name }}</h3>
                                  <div>
                                    <p>{{ value.code }}</p>
                                  </div>
                                  <!-- <div class="text-xs-center">
                                    <product-dialog
                                      :data="value"
                                    ></product-dialog>
                                  </div> -->
                                </div>
                              </v-card-title>
                              <v-card-text>
                                <v-layout column justify-start align-center>
                                  <v-flex xs12>
                                    <product-dialog
                                      :data="value"
                                    ></product-dialog>
                                  </v-flex>
                                </v-layout>
                              </v-card-text>
                          </v-card>
                        </v-hover>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>

                <v-flex xs12 md4>
                  <v-card class="elevation-0 transparent">
                    <v-card-text class="text-xs-center">
                      <v-img
                        :src="require('@/assets/table.png')"
                        :lazy-src="require('@/assets/table.png')"
                        contain
                        aspect-ratio="1.7"
                        height="50"
                        class="">
                      </v-img>
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="text-xs-center" style="font-size:26px">ผลิตภัณฑ์ที่มีคุณภาพ</div>
                    </v-card-title>
                    <v-card-text style="font-size:14px">
                      สินค้าของ NF ใช้วัตถุดิบการผลิตที่ปลอดภัยกว่า
                      <v-spacer></v-spacer>
                      คู่แข่งในตลาดไม่มีการใช้สีมือสอง จึงมีความสวยงาม
                      <v-spacer></v-spacer>
                      มันเงา และทนทาน ประกอบกับช่างที่มีฝีมือและประสบการณ์
                      <v-spacer></v-spacer>
                      ยาวนานจึงได้ออกมาเป็นสินค้าที่มีคุณภาพคงที่
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 md4>
                  <v-card class="elevation-0 transparent">
                    <v-card-text class="text-xs-center">
                      <v-icon x-large class="blue--text text--lighten-2">fas fa-fast-forward</v-icon>
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div style="font-size:26px">การผลิตที่รวดเร็ว</div>
                    </v-card-title>
                    <v-card-text style="font-size:14px">
                      ทางโรงงานของเราเน้นเรื่องความซื่อตรงและการส่งสินค้า
                      ให้ตรงต่อเวลาที่นัดหมายไว้กับลูกค้าเป็นสิ่งสำคัญ เราจึงพยา
                      ยามพัฒนากระบวนการผลิตของเราเพื่อให้รวดเร็ว
                      ตามความต้องการของลูกค้าที่เพิ่มมากขึ้นเสมอ
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 md4>
                  <v-card class="elevation-0 transparent">
                    <v-card-text class="text-xs-center">
                      <v-icon x-large class="blue--text text--lighten-2">fas fa-heart</v-icon>
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="text-xs-center" style="font-size:26px">การบริการด้วยใจ</div>
                    </v-card-title>
                    <v-card-text style="font-size:14px">
                      พนักงานของเราพร้อมให้บริการตอบคำถามของ
                      ลูกค้าไม่ว่าจะเป็นเรื่องสินค้าหรือการบริการและ
                      ตอบโจทย์ความต้องการของคุณลูกค้าเพื่อให้เกิดความพึงพอใจและประโยชน์สูงสุดให้กับลูกค้าทุกท่าน
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </section>

      <section>
        <v-parallax :src="require('@/assets/parallax_home2_1.jpg')" height="400">
          <v-layout column align-center justify-center>
            <div class="white--text mb-3 text-xs-center" style="font-size:24px">ดาวน์โหลดแคตตาล็อกฉบับล่าสุดของเรา</div>
            <em>หรือติดต่อเราเพื่อรับเล่มแคตตาล็อก</em>
            <v-btn
              color="blue lighten-2 mt-5"
              dark
              large
              @click="dialog = true"
            >
              ดาวน์โหลดแค็ตตาล็อก
            </v-btn>

            <v-dialog
              v-model="dialog"
              max-width="350"
            >
              <v-card>
                <v-card-title class="headline">คลิกยืนยันเพื่อดาวน์โหลดแค็ตตาล็อก?</v-card-title>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="green darken-1"
                    flat="flat"
                    @click="dialog = false"
                    :href= "catalogSource"
                    download="catalog"
                  >
                    ยืนยัน
                  </v-btn>

                  <v-btn
                    color="red darken-1"
                    flat="flat"
                    @click="dialog = false"
                  >
                    ยกเลิก
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-layout>
        </v-parallax>
      </section>

      <section>
        <v-container grid-list-xl>
          <v-layout row wrap justify-center class="my-5">
            <v-flex xs12 sm4>
              <v-card class="elevation-0 transparent">
                <v-card-title primary-title class="layout justify-center">
                  <div style="font-size:26px">เกี่ยวกับบริษัท</div>
                </v-card-title>
                <v-card-text>
                  บริษัทที่ถูกก่อตั้งขึ้นในปี 2539 โดยครอบครัว พัฒนะพีระพงศ์ เพื่อประกอบธุรกิจผลิตเฟอร์นิเจอร์จากเหล็ก เพื่อจำหน่ายทั้งในต่างประเทศ และ เริ่มมีการผลิตครั้งแรกที่ตำบลดอนลาน อำเภอผักไห่ จังหวัด พระนครศรีอยุธยา ทางโรงงานของเราเป็นผู้เชี่ยวชาญด้านงานตัด ดัด เชื่อม เจาะ และพ่นสีเหล็ก เพื่อแปรรูปให้เป็นสินค้าเฟอร์นิเจอร์ต่างๆ
                </v-card-text>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12 sm6>
                      <a href="/home">
                        <v-img
                          :src="require('@/assets/logo.png')"
                          :lazy-src="require('@/assets/logo.png')"
                          contain
                          aspect-ratio="1"
                          max-height="120"
                          max-width="120"
                          height="100">
                        </v-img>
                      </a>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <a href="https://www.facebook.com/gamegawinp">
                        <v-img
                          :src="require('@/assets/FWlogo.gif')"
                          :lazy-src="require('@/assets/FWlogo.gif')"
                          contain
                          aspect-ratio="1"
                          max-height="120"
                          max-width="120"
                          height="100">
                        </v-img>
                      </a>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 sm4>
              <v-card class="elevation-0 transparent">
                <v-card-title primary-title class="layout justify-center">
                  <div style="font-size:26px">ติดต่อเรา</div>
                </v-card-title>
                <v-card-text>
                  บริษัท แน็กส์ เฟอร์นิชิ่ง จำกัด (Naics Furnishing Co., Ltd.)
                </v-card-text>
                <v-list class="transparent">
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon class="blue--text text--lighten-2">phone</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>035-795-113, 081-763-2077</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon class="blue--text text--lighten-2">place</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>จังหวัดพระนครศรีอยุธยา, ประเทศไทย</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon class="blue--text text--lighten-2">email</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>kawin@naicsfurnishing.com</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card>
            </v-flex>

            <v-flex xs12 sm4>
              <v-card class="elevation-0 transparent">
                <v-card-title primary-title class="layout justify-center">
                  <div style="font-size:26px">แผนที่</div>
                </v-card-title>
                <v-card-text>
                  <section>
                    <v-layout row>
                      <v-flex xs12>
                        <iframe
                          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15454.803041507808!2d100.274491!3d14.444401!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x654711012df04431!2sNaics+Furnishing+Co.%2C+Ltd.!5e0!3m2!1sen!2sth!4v1540396868501"
                          width="400" height="200" frameborder="0" style="border:0" allowfullscreen></iframe>
                      </v-flex>
                    </v-layout>
                  </section>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </section>
    </v-content>
  </v-app>

  <!-- mobile version -->
  <v-app v-else>
    <home-mobile
      :allUrl="allUrl"
      :popular_product="popular_product"
      :randomList = "randomList">
      </home-mobile>
  </v-app>
</template>

<script>
import ProductDialog from './productDialog.vue'
import HomeMobile from './mobile/homeMobile.vue'
export default {
  components: {
    ProductDialog,
    HomeMobile
  },
  props: ['allData', 'allUrl', 'index_list', 'data_by_category', 'popular_product', 'normal_product', 'childData', 'randomList', 'isLapTopCheck'],
  data () {
    return {
      dialog: false,
      catalogSource: 'https://firebasestorage.googleapis.com/v0/b/game-project-d33f1.appspot.com/o/NF%20JPG-20181015T081448Z-001.zip?alt=media&token=275f3145-1d0a-49f9-a5c8-0e2e4058e452'
    }
  },
  methods: {
    updateValue: function (val) {
      this.$emit('update-child', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home.vue